import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { brand } from "@/data/site/brand";
import { Reveal } from "@/components/motion/Reveal";

interface CTASectionProps {
  heading?: string;
  body?: string;
  variant?: "navy" | "light";
}

export const CTASection = ({
  heading = "The first call is free. The clarity it gives you is the whole point.",
  body = "15 minutes with a credentialed CPA. We'll pull your IRS transcripts, walk through your real options, and tell you honestly whether you need representation — or whether you can handle it yourself.",
  variant = "navy",
}: CTASectionProps) => {
  const isNavy = variant === "navy";
  return (
    <section className={isNavy ? "bg-gradient-navy text-white" : "bg-secondary"}>
      <div className="container mx-auto px-4 py-14 text-center">
        <Reveal>
          <h2 className={`font-heading text-3xl lg:text-4xl font-bold mb-3 ${isNavy ? "" : "text-navy"}`}>
            {heading}
          </h2>
          <p className={`mb-6 max-w-xl mx-auto ${isNavy ? "text-white/80" : "text-muted-foreground"}`}>
            {body}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={`tel:${brand.phoneTel}`}
              className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-dark text-navy font-bold px-7 py-4 rounded text-lg transition-transform hover:scale-[1.03]"
            >
              <Phone className="w-5 h-5" /> Call {brand.phone}
            </a>
            <Link
              to="/free-consultation"
              className={`inline-flex items-center justify-center gap-2 font-semibold px-7 py-4 rounded text-lg border transition-transform hover:scale-[1.03] ${
                isNavy
                  ? "bg-white/10 hover:bg-white/20 text-white border-white/20"
                  : "bg-white hover:bg-secondary text-navy border-border"
              }`}
            >
              Free Consultation <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
